import { $, View } from 'backbone';
import { Consola } from 'consola';
import _ from 'underscore';
import InfoButtonHtml from '../html/infoButton.html';
import InfoPopup from '../html/infoPopup.html';
import { createButtons } from './genericButton';
import { getLogger } from './logging/logger';
import InputManager from './manager/inputManager';
import popUpManager from './manager/popUpManager';
import fetchData from './util/fetch';

const INFO_SECTIONS = Object.freeze({
	infoButton: 'info-button',
	infoPopup: 'info-popup',
});
const ATTRIBUTES = Object.freeze({
	// Info button data
	infoButtonText: 'infoButtonText',
	contentUrl: 'contentUrl',

	// Popup data
	header: 'header',
	content: 'content',
	btns: 'btns',

	// Runtime
	isEnabled: 'isEnabled',
});

export { ATTRIBUTES, INFO_SECTIONS };

class InfoButton extends View {
	get CN() {
		return InfoButton.name;
	}

	/** @type {Consola} */
	get logger() {
		return getLogger(this.CN);
	}

	className() {
		return 'info';
	}

	get infoButtonTemplate() {
		return _.template(InfoButtonHtml);
	}

	get popupTemplate() {
		return _.template(InfoPopup);
	}

	events() {
		return {
			'click .btn-info': this.showPopup,
		};
	}

	initialize(options) {
		this.logger.log(`[${this.initialize.name}]`, { options });

		// * Info button data
		this[ATTRIBUTES.infoButtonText] = '';
		this[ATTRIBUTES.contentUrl] = '/hwpHub/json/infoPopupData.json';

		// * Popup data
		this[ATTRIBUTES.header] = {};
		this[ATTRIBUTES.content] = {};
		this[ATTRIBUTES.btns] = [];

		/** @type {boolean} whether or not the info button is visible */
		this[ATTRIBUTES.isEnabled] = false;

		Object.assign(this, options);

		InputManager.add(INFO_SECTIONS.infoButton, {
			selector: '.info .btn-info',
		});

		return fetchData(this[ATTRIBUTES.contentUrl])
			.catch(() => this.logger.error('failed to get info popup data'))
			.then((data) => Object.assign(this, data));
	}

	render() {
		this.logger.log(`[${this.render.name}]`);

		this.$el.empty().append(this.infoButtonTemplate({ text: this.infoButtonText }));
	}

	disable() {
		this.logger.log(`[${this.disable.name}]`);
		this.isEnabled = false;
		this.$el.hide();
		this.$el.empty();
	}

	enable() {
		this.logger.log(`[${this.enable.name}]`);
		this.render();
		this.isEnabled = true;
		this.$el.show();
	}

	showPopup() {
		this.logger.log(`[${this.showPopup.name}]`);

		const { header, content, btns = [] } = this;

		const infoPopUp = $(this.popupTemplate({ ...header, ...content, btns }))
			.append(
				createButtons([
					...btns, // Additional buttons from content
					{ id: 'close', text: ['Close'], className: 'btn btn-close' }, // Always have a close button
				]),
			)
			.get(0);

		popUpManager.displayPopUp({ contentHtml: infoPopUp });
	}
}

export default new InfoButton();
